import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// TODO: Security Enhancement - Consider migrating token storage from localStorage to httpOnly cookies
// localStorage is vulnerable to XSS attacks. httpOnly cookies with CSRF protection provide better security.
// This requires backend changes to set cookies and handle CSRF tokens.

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Normalize error detail - Pydantic returns array of objects, convert to string
const normalizeErrorDetail = (detail) => {
  if (!detail) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (typeof d === "string" ? d : d?.msg || JSON.stringify(d))).join(". ");
  }
  if (typeof detail === "object") return detail.msg || JSON.stringify(detail);
  return String(detail);
};

// Handle auth errors and normalize error responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    // Normalize detail field to always be a string
    if (error.response?.data?.detail) {
      error.response.data.detail = normalizeErrorDetail(error.response.data.detail);
    }
    return Promise.reject(error);
  }
);

export default api;
